export default {
  title: 'Er du sikker?',
  description: 'Følgende modifikatorgrupper (inklusive deres modifikatorer) slettes:',
  buttons: {
    yes: 'Ja',
    no: 'Nej',
  },
  toasts: {
    modifier_group_got_deleted: 'Modifikatorgrupper er slettet',
    failed_to_delete_modifier_group: 'Modifikatorgruppen kunne ikke slettes',
  },
};
